module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.bd45e4d8.jpg";